import React, { FC } from 'react';

const Music: FC = () => {
  return <div>MUSIC</div>;
};

export default Music;
